<template>
  <section class="tn-section">
    <h2 class="tn-section__title"><slot name="title">{{title}}</slot></h2>
    <slot></slot>
  </section>
</template>
<script>
  export default {
    name: 'tn-section',
    props: ['title']
  };
</script>
